import * as React from 'react';
import { Route, Switch } from 'react-router';
import { Karma } from './Karma';
import { AdminView } from './views/Config/Admin';
import { GenView } from './views/GenView';
import { Home } from './views/Home';
import { Layout } from './views/Layout';
import { LoginView } from './views/LoginView';
import { NotFoundView } from './views/NotFoundView';
import { Authentication } from './views/Authentication';
import { Stress } from './views/Stress';
import { X3Admin } from './views/X3Admin';
import './_root.scss';


interface IProps {}

class App extends React.Component<IProps> {
	constructor(props: IProps) {
		super(props);

		console.debug("New Karma WMS instance (" + Karma.getCurrentCultureCode() + ")")

		// Les langues sont maintenant uniquement d�finies sur la page d'accueil et ne sont plus modifiables en temps r�el.
		// D�commenter la ligne ci-dessus pour r�activer cette possiblit�
		//
		// Karma.OnCultureChanged.add((culture) => { this.forceUpdate() });
		Karma.OnRefresh.add(() => { this.forceUpdate() });
	}

	render() {
		return (
			<Layout>
				<Switch >
					<Route exact path='/' component={Home} />
					<Route path="/Home/:menu?" component={Home} />

					<Route path={LoginView.URL} component={LoginView} />
					<Route exact path={GenView.URL + '/:fnct'} component={GenView} />
					<Route path={AdminView.URL} component={AdminView} />
					<Route path={Authentication.URL} component={Authentication} />
					<Route path={Stress.URL} component={Stress} />

					<Route path={X3Admin.URL} component={X3Admin} />
					<Route component={NotFoundView} />
				</Switch>
			</Layout>
		);
	}
}

export default App;
